import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { marketplaceGroupsResponse } from './MarketplaceGroups.js';

export const marketplaceGroupsTransformSchema = marketplaceGroupsResponse.transform((result) => ({ data: result }));

export const marketplaceGroupsApiResponse = {
  parse: (data: unknown) => z.union([marketplaceGroupsTransformSchema, apiErrorSchema]).parse(data),
} as const;
